import React, { Component } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"

//SimpleBar
import SimpleBar from "simplebar-react"
// import images
import user1 from "../../assets/images/users/avatar-6.jpg"
import user2 from "../../assets/images/users/avatar-4.jpg"
import user3 from "../../assets/images/users/avatar-5.jpg"

export default class Comments extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <React.Fragment>
          <Card>
            <CardBody>
              <div className="d-flex flex-wrap">
                <div className="me-2">
                  <h5 className="card-title mb-3">Latest Chats</h5>
                </div>
                <UncontrolledDropdown className="ms-auto">
                  <DropdownToggle
                    className="text-muted font-size-16"
                    color="white"
                    type="button"
                    tag="a"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </DropdownToggle>
                  <DropdownMenu direction="right" className="dropdown-menu-end">
                    <Link className="dropdown-item" to="#">
                      Reply
                    </Link>
                    <Link className="dropdown-item" to="#">
                      Add New
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link className="dropdown-item" to="#">
                      Clear All
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <SimpleBar style={{ maxHeight: "310px" }}>
                <div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item py-3">
                      <div className="media">
                        <div className="avatar-xs me-3">
                          <div className="avatar-title rounded-circle bg-light text-primary">
                          <img
                            src={user2}
                            alt=""
                            className="img-fluid d-block rounded-circle"
                          />
                          </div>
                        </div>
                        <div className="media-body">
                          <h5 className="font-size-14 mb-1">
                            Odilia Alexandra{" "}
                            <small className="text-muted float-end">
                              06/10/2019
                            </small>
                          </h5>
                          <p className="text-muted">
                            Hey, can we talk about HSBC? Robert is putting the opportunity at risk ...
                          </p>
                          <div>
                            <Link to="#" className="text-success">
                              <i className="mdi mdi-reply me-1"></i> Reply
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item py-3">
                      <div className="media">
                        <div className="avatar-xs me-3">
                          <img
                            src={user1}
                            alt=""
                            className="img-fluid d-block rounded-circle"
                          />
                        </div>
                        <div className="media-body">
                          <h5 className="font-size-14 mb-1">
                          Florrie Lesly{" "}
                            <small className="text-muted float-end">
                            06/09/2019
                            </small>
                          </h5>
                          <p className="text-muted">
                            Awesome readout for Bank of America, loved the demo!
                          </p>
                          <div>
                            <Link to="#" className="text-success">
                              <i className="mdi mdi-reply"></i> Reply
                            </Link>
                          </div>

                          <div className="media pt-3">
                            <div className="avatar-xs me-3">
                              <div className="avatar-title rounded-circle bg-light text-primary">
                              <img
                            src={user3}
                            alt=""
                            className="img-fluid d-block rounded-circle"
                          />
                              </div>
                            </div>
                            <div className="media-body">
                              <h5 className="font-size-14 mb-1">
                                Jason Ezekiel{" "}
                                <small className="text-muted float-end">
                                06/10/2019
                                </small>
                              </h5>
                              <p className="text-muted">
                                Agreed, this tech is sick 🙌
                              </p>
                              <div>
                                <Link to="#" className="text-success">
                                  <i className="mdi mdi-reply"></i> Reply
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="list-group-item py-3">
                      <div className="media">
                        <div className="avatar-xs me-3">
                          <div className="avatar-title rounded-circle bg-light text-primary">
                            <i className="bx bxs-user"></i>
                          </div>
                        </div>
                        <div className="media-body">
                          <h5 className="font-size-14 mb-1">
                            Keith McCoy{" "}
                            <small className="text-muted float-end">
                            06/08/2019
                            </small>
                          </h5>
                          <p className="text-muted">
                            You rock!
                          </p>
                          <div>
                            <Link to="#" className="text-success">
                              <i className="mdi mdi-reply"></i> Reply
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </SimpleBar>
            </CardBody>
          </Card>
      </React.Fragment>
    )
  }
}
